import { render, staticRenderFns } from "./TabsBar.vue?vue&type=template&id=fedbf9d8&scoped=true&"
import script from "./TabsBar.vue?vue&type=script&lang=js&"
export * from "./TabsBar.vue?vue&type=script&lang=js&"
import style0 from "./TabsBar.vue?vue&type=style&index=0&id=fedbf9d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedbf9d8",
  null
  
)

export default component.exports